package com.arena_web.data.http

import io.ktor.client.plugins.HttpRequestTimeoutException

// What each browser's fetch() rejects with when the network drops mid-request:
// Chrome "Failed to fetch", Firefox "NetworkError when attempting to fetch
// resource", Safari "Load failed" / "The Internet connection appears to be
// offline". Ktor's Js engine surfaces these as generic Throwables, so type
// checks don't work — the message is the only signal.
private val NETWORK_ERROR_MARKERS = listOf(
    "failed to fetch",
    "fail to fetch",
    "networkerror",
    "load failed",
    "network request failed",
    "internet connection appears to be offline",
)

/**
 * True for transport-level failures the user can fix by getting back online.
 * Server-side errors (4xx/5xx bodies) are NOT network errors.
 */
fun Throwable.isNetworkError(): Boolean {
    if (this is HttpRequestTimeoutException) return true
    var t: Throwable? = this
    while (t != null) {
        val m = t.message?.lowercase()
        if (m != null && NETWORK_ERROR_MARKERS.any { it in m }) return true
        t = t.cause?.takeIf { it !== t }
    }
    return false
}
